module.exports = __webpack_public_path__ + "static/media/shangcheng_icon@3x.1e908d28.png";